module.exports = __webpack_public_path__ + "8500da6d2b0b150c89efa01225c7b567.png";